export default __webpack_public_path__ + "static/media/oneTomoea.4d7fd1ea.png";